import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';

const mapStateToProps = state => ({
  fw_gdpr_consent1: state.fw_gdpr_consent1,
});

@connect(mapStateToProps)
@appContext
export default class OneTrust extends React.PureComponent {

	constructor(props) {
    	super(props);

	    this.state = {
	      fw_gdpr_consent1: 11,
	      
	    };      
   
  	}
  componentDidMount() {
  		//if (this.props.new_fw_gdpr_consent !== -1) {
    		this.setState({
                fw_gdpr_consent1: this.props.new_fw_gdpr_consent,
              });
          //}
 }

  render() {
    return <div><h1>{this.state.fw_gdpr_consent1}</h1>
    				-{this.props.new_fw_gdpr_consent}</div>;
  }
}


// WEBPACK FOOTER //
// ./src/component/Page/OneTrust.jsx